import { PledgeTransactionTypeEnum } from '@tassat/common-definitions';
import { FormModal } from '@tassat/modal';
import { convertToNumber } from '@tassat/utility';
import React from 'react';

import Worker from 'Lib/worker/PrimusWorker';
import { useAppSelector } from 'Reducers/store/hooks';
import { getSecurityCurrencyPairBySecurityTicker } from 'Selectors/assets';
import { getPledgeDetail, getUserId } from 'Selectors/common';

import ReclaimForm from './reclaimForm/reclaimForm';
import { IReclaimFormValues, ReclaimPledgeRequest } from './reclaimForm/types';
import { PledgeContextWorkflowContext } from '../../../pledgeContextWorkflow';
import { ModalComponentProps } from '../../types';

function Reclaim(props: ModalComponentProps) {
    const { pledgeContextWorkflowState, dispatchPledgeContextWorkflowAction } = React.useContext(PledgeContextWorkflowContext)!;
    const { selectedPledge } = pledgeContextWorkflowState;
    const pledgeDetail = useAppSelector(getPledgeDetail);

    const userId = useAppSelector(getUserId);
    const assetPair = useAppSelector((state) => getSecurityCurrencyPairBySecurityTicker(state, selectedPledge?.Ticker));

    const handleClose = () => {
        dispatchPledgeContextWorkflowAction({
            type: 'CHANGE_MODAL_SCREEN',
            payload: { screen: 'details' }
        });
    };

    const handleReclaim = async (values: IReclaimFormValues) => {
        if (!pledgeDetail || !assetPair.security?.Ticker) return;
        try {
            const AssetQuantity = convertToNumber(values?.AssetAmount);
            const reclaimPledgeRequestValues: ReclaimPledgeRequest = {
                UserId: userId,
                PledgeId: pledgeDetail.PledgeId,
                AssetQuantity,
                Ticker: assetPair.security.Ticker,
                ApprovalNeeded: props.approvalNeeded
            };
            dispatchPledgeContextWorkflowAction({
                type: 'SET_MODAL_PLEDGE_VALUES',
                payload: {
                    PledgeId: reclaimPledgeRequestValues.PledgeId,
                    AssetQuantity: reclaimPledgeRequestValues.AssetQuantity,
                    Ticker: reclaimPledgeRequestValues.Ticker,
                    PledgeParticipant: pledgeDetail.PledgeParticipant
                }
            });
            dispatchPledgeContextWorkflowAction({
                type: 'SET_PLEDGE_TYPE',
                payload: PledgeTransactionTypeEnum.reclaim
            });
            dispatchPledgeContextWorkflowAction({
                type: 'CHANGE_MODAL_SCREEN',
                payload: { screen: 'details' }
            });
            dispatchPledgeContextWorkflowAction({
                type: 'SET_PLEDGE_ACTION_IN_PROGRESS',
                payload: true
            });
            await Worker.getInstance()
                .createPledgeReclaim(reclaimPledgeRequestValues);
        } catch (error) {
            console.error(error);
        }
    };

    const formData = {
        pledge: pledgeDetail,
        assetPair,
        handleReclaim
    };

    return (
        <FormModal
            Form={ReclaimForm}
            formProps={formData}
            formType='actionForm'
            modalWidth='40%'
            onClose={handleClose}
            open
            title='Reclaim'
        />
    );
}

export { Reclaim };